import { wealthProApi } from '../../redux/api';

const hoAdminIgnoredPlatformAccountsApiEndpoints = wealthProApi.enhanceEndpoints({
    addTagTypes: ["platformAccountDesignationMap", "TransactionMatches"]
})
    .injectEndpoints({
        endpoints: (builder) => ({

            createHeadOfficeIgnoredPlatformAccount: builder.mutation({
                query: (request) => ({
                    url: 'api/headofficeadmin/ignoredPlatformAccounts',
                    method: 'POST',
                    body: request
                }),
                invalidatesTags: ["platformAccountDesignationMap"]
            }),
        })
    });

export const {
    useCreateHeadOfficeIgnoredPlatformAccountMutation
} = hoAdminIgnoredPlatformAccountsApiEndpoints;